import { api } from '@api/api2';

export const getResidentTypesFilter = () =>
  api.v4('get', 'residents-new/support/available-resident-type-filter');
